document.addEventListener('DOMContentLoaded', function(){
    let buttonTriggerSearch = document.querySelector('.custom-search-mobile');
    let drawerTrigger = document.querySelector('.custom-header-search')
    buttonTriggerSearch.addEventListener('click', function(){{
        if(drawerTrigger.classList.contains('active')){
            drawerTrigger.classList.remove('active');
        }else{
            drawerTrigger.classList.add('active');
        }
    }})
})

document.addEventListener("DOMContentLoaded", () => {
  const form = document.querySelector("#wsaio-form");

  if (!form) return; 
  const setCountryToUS = (select) => {
    if (select && select.tagName === "SELECT") {
      select.value = "United States";
      select.dispatchEvent(new Event("change", { bubbles: true }));
      console.log("✅ Country auto-selected: United States");
    }
  };

  const existingSelect = form.querySelector("#waio--address_country");
  if (existingSelect) {
    setCountryToUS(existingSelect);
    return; 
  }

  const observer = new MutationObserver((mutationsList, obs) => {
    for (const mutation of mutationsList) {
      for (const node of mutation.addedNodes) {
        if (
          node.nodeType === 1 &&
          node.matches &&
          node.matches("#waio--address_country")
        ) {
          setCountryToUS(node);
          obs.disconnect(); 
          return;
        }

        if (node.querySelector) {
          const select = node.querySelector("#waio--address_country");
          if (select) {
            setCountryToUS(select);
            console.log('set select')
            obs.disconnect();
            return;
          }
        }
      }
    }
  });

  observer.observe(form, { childList: true, subtree: true });
});




document.addEventListener("DOMContentLoaded", () => {

  const wait = setInterval(() => {
    const form = document.querySelector("form.g-container");

    if (form) {
      clearInterval(wait);
      handleFormValidation(form);
    }
  }, 300);

  function handleFormValidation(form) {
    form.addEventListener("submit", function (e) {
      const customProductForm = document.querySelector('.globo-app-extension form.g-container');
            
      const options = customProductForm.querySelectorAll('.gfb__image-option__list');
      const images  = customProductForm.querySelectorAll('.gfb__dropzone .gfb__dropzone--content .gfb__dropzone--preview--area');
      const qtys    = customProductForm.querySelectorAll('.input-qty input.material_filled-input');

      let error = false;
      let firstErrorElement = null;

      customProductForm.querySelectorAll('.error-text').forEach(el => el.remove());
      customProductForm.querySelectorAll('.error-input').forEach(el => el.classList.remove('error-input'));

      options.forEach((opt, index) => {
        const image = images[index];
        const qty   = qtys[index];

        const imageFileName = image.querySelector('.gfb__dropzone--preview--item-filename');
        const hasImage = imageFileName?.textContent.trim();

        const isSelectedCheckbox = opt.querySelector('input[type="checkbox"]:checked');
        const isSelectedRadio = opt.querySelector('input[type="radio"]:checked');

        if (isSelectedCheckbox || isSelectedRadio) {
          const qtyParent = qty.closest('.globo-form-control');
          if (!qty.value.trim()) {
            error = true;

            qtyParent.querySelector('.globo-form-input').classList.add('error-input');
            if (!firstErrorElement) firstErrorElement = qty;

            const errorMsg = document.createElement("div");
            errorMsg.className = "error-text";
            errorMsg.textContent = "Quantity is required.";
            qtyParent.appendChild(errorMsg);

          } else {
            qtyParent.querySelector('.globo-form-input')?.classList.remove('error-input');
          }

          const imageParent = image.closest('.globo-form-control');
          if (!hasImage) {
            error = true;

            imageParent.querySelector('.globo-form-input').classList.add('error-input');
            if (!firstErrorElement) firstErrorElement = image;

            const errorMsg = document.createElement("div");
            errorMsg.className = "error-text";
            errorMsg.textContent = "Image is required.";
            imageParent.appendChild(errorMsg);

          } else {
            imageParent.querySelector('.globo-form-input')?.classList.remove('error-input');
          }
        }
      });

      console.log(e);
      

      if (error) {
        e.stopImmediatePropagation(); 
        e.preventDefault();
        firstErrorElement.scrollIntoView({
          behavior: "smooth",
          block: "center"
        });
      }
    });
  }

})